import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
// React Grid Layout CSS - required for drag/drop and resize functionality
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import App from './App'

const isDev = import.meta.env.MODE === 'development'

createRoot(document.getElementById('root')!).render(
  isDev ? (
    <StrictMode>
      <App />
    </StrictMode>
  ) : (
    <App />
  ),
)
